import TabularUSPs from './TabularUSPs'

export default TabularUSPs
